class Contact {
  constructor(root) {
    this.root = root;
    this.buttons = [...this.root.querySelectorAll('.Contact-buttons a')];
    this.tabs = [...this.root.querySelectorAll('.Contact-tabs .Tab')];

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        this.buttons.forEach((button) => button.classList.remove('isActive'));
        e.target.classList.toggle('isActive');
        this.tabs.forEach((tab) => tab.classList.remove('isActive'));
        this.tabs[index].classList.toggle('isActive');
      });
    });
  }
}

[...document.querySelectorAll('.Contact')].forEach((node) => {
  new Contact(node);
});